module.exports = __webpack_public_path__ + "static/img/mediamodifier_image_3.6b5f7a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mediamodifier_image_3.png
// module id = 2KJD
// module chunks = 0